import { Self, Component, OnInit,ViewChild, ViewContainerRef, Renderer2 } from '@angular/core';
import { ControlValueAccessor,NG_VALUE_ACCESSOR, NG_VALIDATORS, NgControl, Validators } from '@angular/forms';
import {Overlay,OverlayConfig, OverlayRef} from '@angular/cdk/overlay';
import {ComponentPortal,Portal,TemplatePortalDirective} from '@angular/cdk/portal';
import { ColourPickerService } from './colour-picker.service';
@Component({
  selector: 'app-colour-picker',
  templateUrl: './colour-picker.component.html',
  styleUrls: ['./colour-picker.component.css']
})
export class ColourPickerComponent implements OnInit, ControlValueAccessor {
  _isOnChange: (value: any) => void;
  overlayRef: OverlayRef;
    @ViewChild('overlayTemplate', {static:false}) overlayTemplate: TemplatePortalDirective;
  colorCodes =   [{ colorCode: '#EADBC8', colorValue: 'navy' },
    { colorCode: '#E7F0DC', colorValue: 'blue' },
    { colorCode: '#F5DAD2', colorValue: 'aqua' },
     { colorCode: '#AFD5EA', colorValue: 'pink' },
     { colorCode: '#7DF7CA', colorValue: 'green' },
     { colorCode: '#C6BEEE', colorValue: 'green' },
     { colorCode: '#B6B4F2', colorValue: 'lime' },
     { colorCode: '#C2E3EE', colorValue: 'yellow' },
     { colorCode: '#EED68F', colorValue: 'orange' },
     { colorCode: '#A6D3EA', colorValue: 'maroon' },
     {colorCode:'#EEA3C6',colorValue:'default'}
  ]; 
    constructor(public overlay: Overlay, public viewContainerRef: ViewContainerRef,
                 public colourPickerService:ColourPickerService
    ) {
     

    }
  
    ngOnInit() {
   
    }
  
    writeValue(colorValue: any): void {
      if(colorValue){
        this.colourPickerService.selctedColor = colorValue;
      }
    }
  
    registerOnChange(fn: (_: any) => void) {
      this._isOnChange = fn;
    }
  
    registerOnTouched(fn: any): void {}
  
  
   showColorPallate() {
     this.colourPickerService.showColorPallateContainer = !this.colourPickerService.showColorPallateContainer;
   }
  
   onSelect(codes:any){
    this.colourPickerService.showColorPallateContainer = false;
      this.colourPickerService.selctedColor = codes.colorCode;
      this._isOnChange(codes);
   }
   selectedOverlay(){
       this.colourPickerService.showColorPallateContainer = false;
   }
  
  
  }